export const getHost = () => typeof window === 'object'
    ? `${window.location.protocol}//${window.location.host}`
    : '';
